export default "__VITE_ASSET__CpKHEHrP__"